import { z } from 'zod';
import { StatusEnum, StatusTypeSchema } from '../enums/status';

export const applicationSchema = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  createdOn: z.coerce.date(),
  createdBy: z.object({
    id: z.coerce.number(),
    name: z.string(),
  }).nullable(),
  status: StatusTypeSchema.default(StatusEnum.Draft),
  icon: z.string().optional(),
});
export type Application = z.infer<typeof applicationSchema>;